import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, OnChanges } from '@angular/core';
import { Multivenue, VenueTab, SitesBuilderLibComponent } from '@3ddv/ngx-sites-builder-lib';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-multivenue-item',
  templateUrl: './multivenue-item.component.html',
  styleUrls: ['./multivenue-item.component.scss', '../multivenue.component.scss'],
})
export class MultivenueItemComponent implements OnInit, OnDestroy, OnChanges {
  @Input() venueTab: VenueTab;
  @Input() mode: 'edit' | 'create';
  @Input() isDefaultTab: boolean;

  @Output() createdVenueTab = new EventEmitter<VenueTab>();
  @Output() editedVenueTab = new EventEmitter<VenueTab>();

  private subscriptions: Array<Subscription>;

  public imgPreview: any;
  private s3_path = '/latest/tools/multivenue/';
  constructor(private toastrService: ToastrService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    this.refreshInput();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  ngOnChanges(): void {
    this.refreshInput();
  }

  private refreshInput() {
    if (this.venueTab.file) {
      const name_spplitted = this.venueTab.file.name.split('.');
      const ext = name_spplitted[name_spplitted.length - 1];
      const reader = new FileReader();
      reader.readAsDataURL(this.venueTab.file);
      reader.onload = _event => {
        this.imgPreview = reader.result;
        this.venueTab.path = this.s3_path + this.venueTab.id + '.' + ext;
        // console.log('Img Preview (File): ', this.imgPreview);
      };
    } else if (this.venueTab.logoPreview) {
      this.imgPreview = this.venueTab.logoPreview;
      // console.log('Img Preview (LogoPreview): ', this.imgPreview);
    }
  }

  public onSelectType($event) {
    switch ($event.target.options.selectedIndex) {
      case 0: {
        this.venueTab.type = 'icon';
        break;
      }
      case 1: {
        this.venueTab.type = 'text';
        break;
      }
    }
  }

  public deleteDroppedFile() {
    this.venueTab.file = null;
    this.imgPreview = null;
  }

  public onFileSelected(event) {
    this.venueTab.file = null;
    if (!event.target.files.length) return;

    this.venueTab.file = event.target.files[0];
    const name_spplitted = this.venueTab.file.name.split('.');
    const ext = name_spplitted[name_spplitted.length - 1];
    const reader = new FileReader();
    reader.readAsDataURL(this.venueTab.file);
    reader.onload = _event => {
      this.imgPreview = reader.result;
      this.venueTab.path = this.s3_path + this.venueTab.id + '.' + ext;
    };
  }

  public onFileDropped($event) {
    if (
      ($event[0].type == '' && $event[0].size == 0) ||
      ($event[0].type != 'image/jpeg' && $event[0].type != 'image/png')
    ) {
      this.toastrService.error('', 'Formato del fichero inválido');
      return;
    }
    this.venueTab.file = $event[0];
    const name_spplitted = this.venueTab.file.name.split('.');
    const ext = name_spplitted[name_spplitted.length - 1];
    var reader = new FileReader();
    reader.readAsDataURL($event[0]);
    reader.onload = _event => {
      this.imgPreview = reader.result;
      this.venueTab.path = this.s3_path + this.venueTab.id + '.' + ext;
    };
  }

  public addVenueTab() {
    if (this.venueTab.type === 'icon') {
      this.venueTab.name = '';
    } else if (this.venueTab.type === 'text') {
      this.venueTab.file = null;
      this.venueTab.logoPreview = null;
      this.venueTab.path = '';
    }
    console.log('venueTab (creating item): ', this.venueTab);

    if (this.mode === 'create') {
      this.createdVenueTab.emit(Object.assign({}, this.venueTab));
    } else if (this.mode === 'edit') {
      this.editedVenueTab.emit(Object.assign({}, this.venueTab));
    }
    this.imgPreview = null;
  }

  public setNewTab(venueTab: VenueTab) {
    this.venueTab = venueTab;
  }
}
